<p-confirmDialog appendTo="body" (onHide)="close()" [closable]="false">
  <ng-template #header>
    <p
      class="font-bold text-xl"
      [innerHTML]="dialogHeader | highlight: '¡Critico!'"
    ></p>
  </ng-template>
  <ng-template #footer>
    @if (cancelButton) {
      <div class="flex justify-between pt-4 w-full">
        <petrol-button variant="primary" (click)="onAccept()">Confirmar</petrol-button>
        <petrol-button variant="tertiary" (click)="onReject()">Cancelar</petrol-button>
      </div>
    } @else {
      <petrol-button variant="primary" (click)="onAccept()">Confirmar</petrol-button>
    }
  </ng-template>
</p-confirmDialog>
